{
  "Dashboard": {
    "Welcome": "Welcome",
    "Properties": {
      "Title": "Properties",
      "Description": "Here you can find all your properties at a glance."
    },
    "Buildings": {
      "Title": "Buildings",
      "Description": "Here you can find all your buildings at a glance."
    },
    "Units": {
      "Title": "Units",
      "Description": "Here you can find all your units at a glance."
    },
    "Widgets": {
      "WorkQueue": "Work Queue",
      "FinancialPulse": "Financial Pulse"
    }
  },
  "Language Picker": {
    "Label": "Language"
  },
  "Navigation": {
    "Start": "Start",
    "Dashboard": "Dashboard",
    "Properties": "Properties",
    "Buildings": "Buildings",
    "Units": "Units",
    "Documents": "Documents",
    "Profile": "Profile",
    "Settings": "Settings"
  },
  "List": {
    "Pagination": {
      "Items per page": "Items per page",
      "Page from total": "Page {{ page }} of {{ total }}"
    },
    "Header": {
      "Selected": "{{ selected }} of {{ total }} selected"
    },
    "Filter": {
      "Clear all": "Clear all",
      "Open": "Open filter",
      "From": "From",
      "To": "To"
    },
    "Actions": {
      "Label": "Actions",
      "View": "View",
      "Delete": "Delete",
      "Edit": "Edit"
    },
    "ModifiedAt": "Last modified"
  },
  "User": {
    "User": "User",
    "Users": "Users",
    "Search for users": "Search for users",
    "Colleague": "Colleague",
    "Search for colleagues": "Search for colleagues",
    "Roles": {
      "SuperAdministrator": "Super Administrator",
      "User": "User"
    }
  },
  "Form": {
    "Fields": {
      "Searcher": {
        "No entities found": "No {{ entity }} found",
        "Search for entities": "Search for {{ entity }}",
        "Create new entity": "Create new {{ entity }}"
      },
      "Errors": {
        "Required": "{{ field }} is required",
        "Unknown": "Unknown error for {{ field }}",
        "Email": "{{ field }} must be a valid email address",
        "Min": "{{ field }} must be greater than or equal to {{ min }}",
        "Max": "{{ field }} must be less than or equal to {{ max }}",
        "MinLength": "{{ field }} must be at least {{ minLength }} characters long",
        "MaxLength": "{{ field }} must be at most {{ maxLength }} characters long",
        "Pattern": "{{ field }} has an invalid format",
        "NumberTaken": "{{ field }} is already taken"
      }
    },
    "Errors": {
      "Validation": "Please correct the highlighted fields."
    },
    "Actions": {
      "Submit": "Submit",
      "Cancel": "Cancel",
      "Reset": "Reset",
      "Save": "Save"
    }
  },
  "Error": {
    "Not Found": {
      "Title": "Page Not Found",
      "Description": "The page you are looking for does not exist or has been moved.",
      "Back to Dashboard": "Back to Dashboard"
    }
  },
  "Thread": {
    "Action": {
      "React": "React",
      "Reply": "Reply",
      "Collapse": "Collapse",
      "Expand": "Expand",
      "Cancel": "Cancel",
      "Send": "Send"
    },
    "Reply": "Reply",
    "Replies": "Replies",
    "Reply placeholder": "What do you think about that?",
    "Reply success": "Your reply has been sent successfully.",
    "Message": {
      "Reaction": {
        "Like": "Like",
        "Dislike": "Dislike"
      }
    }
  }
}
